import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import AlternarSoporte from "./OpcionesMenuSoporte/HabilitarDeshabilitarSoporte"

const useStyles = makeStyles((theme) => ({
    iconMenu: {
        color: "#fafafa"
    }

}));

const StyledMenu = withStyles({
    paper: {
        backgroundColor: "#fafafa",
        border: '0px',
    },
})((props) => (
    <Menu
        elevation={5}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'center',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles((theme) => ({
    root: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);

function SoporteOpciones({ id, anchorEl, setAnchorEl, open, onClose, setPulse }) {
    const classes = useStyles();
    

    return (
        <StyledMenu
            id={id}
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={onClose}

        >   
        {// Alternar Soporte es un StyledMenuItem modularizado en otro componente
        }
            <AlternarSoporte anchorEl={anchorEl} setAnchorEl={setAnchorEl} setPulse={setPulse}/>
            {/* ejemplo de como agregar otro item a la lista
                
                <StyledMenuItem>
                    <ListItemIcon>
                        <SendIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Sent mail" />
                </StyledMenuItem>
                
            */}
        </StyledMenu>
    );
}
export default SoporteOpciones